module.exports = __webpack_public_path__ + "img/Rectangle 4.ecc5a7c2.png";